import React, { useMemo, useState } from 'react';
import { defineMessages } from 'react-intl';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFormField from '@hooks/useFormField';
import useTranslate from '@hooks/useTranslate';
import { IconSquareX } from '@tabler/icons-react';
import { Form, Upload } from 'antd';
import ImgCrop from 'antd-img-crop';

const messages = defineMessages({
    required: {
        id: 'form.field.required',
        defaultMessage: 'Vui lòng chọn ảnh',
    },
});

function CropImageFieldModal({
    label,
    fileList,
    disabled,
    name,
    valuePropName,
    accept,
    onChange,
    beforeUpload,
    showUploadList,
    aspect = 1,
    maxFile = 1,
    imageUrl,
    loading,
    style,
    required,
    formItemProps,
    imgUploadedSizeAuto,
    handleRemoveImage,
    leftIconRemove = 68,
    styleUploadButton,
    isBanner = false,
    isNoCrop = false,
    onUploadSuccess, // callback để đóng modal và gán giá trị
    ...props
}) {
    const translate = useTranslate();
    const { rules } = useFormField(props);
    const [hoverItem, setHoverItem] = useState(false);

    // Validate rules động
    const updatedRules = useMemo(() => {
        if (required) {
            return [
                ...(rules || []),
                {
                    required: !imageUrl && !fileList?.length,
                    message: translate.formatMessage(messages.required),
                },
            ];
        }
        return rules;
    }, [required, rules, label, imageUrl, fileList, translate]);

    // Xử lý upload
    // const onUploadFile = ({ file }) => {
    //     const { uploadFile } = props;
    //     uploadFile(file, (uploadedUrl) => {
    //         console.log("uploadedUrl",uploadedUrl);
    //         console.log(file);
    //         if (uploadedUrl) {
    //             // Gọi callback để đóng modal và gán giá trị cho form
    //             onUploadSuccess?.(uploadedUrl);
    //         }
    //     });
    // };

    const onUploadFile = ({ file }) => {
        const { uploadFile } = props;
        uploadFile(file);
        onUploadSuccess?.();
    };

    const renderUploadButton = () => (
        <div className="upload-wrapper" style={styleUploadButton}>
            {!showUploadList && loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div className="ant-upload-text">{loading ? 'Đang tải...' : 'Tải ảnh lên'}</div>
        </div>
    );

    const getContent = () => {
        if (imageUrl && !loading) {
            return (
                <div
                    style={{ margin: 4, maxWidth: '100%', ...styleUploadButton }}
                    onMouseMove={() => setHoverItem(true)}
                    onMouseLeave={() => setHoverItem(false)}
                    className={!isBanner && 'upload-wrapper'}
                >
                    <img
                        style={{ maxWidth: '100%', objectFit: 'contain', ...styleUploadButton }}
                        className="img-uploaded"
                        src={imageUrl}
                        alt="field-upload"
                    />
                    {hoverItem && (
                        <IconSquareX
                            style={{
                                position: 'absolute',
                                top: 2,
                                left: leftIconRemove,
                                cursor: 'pointer',
                                color: 'white',
                                fill: 'red',
                                width: 30,
                                height: 30,
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveImage?.();
                            }}
                            onMouseMove={() => setHoverItem(true)}
                            onMouseLeave={() => setHoverItem(false)}
                        />
                    )}
                </div>
            );
        } else if (showUploadList && fileList && fileList.length === maxFile) {
            return null;
        }
        return renderUploadButton();
    };

    const uploadClass = useMemo(() => {
        return ['avatar-uploader', imgUploadedSizeAuto && 'img-uploaded-size-auto'].filter(Boolean).join(' ');
    }, [imgUploadedSizeAuto]);

    return (
        <Form.Item
            {...formItemProps}
            required={required}
            label={label}
            name={name}
            rules={updatedRules}
            valuePropName={valuePropName}
        >
            {showUploadList ? (
                <ImgCrop aspect={aspect} fillColor="transparent" quality="1">
                    <Upload
                        fileList={fileList}
                        disabled={disabled}
                        accept={accept}
                        name="field-upload"
                        listType="picture-card"
                        style={{ width: '100%' }}
                        customRequest={onUploadFile}
                        beforeUpload={beforeUpload}
                        onChange={onChange}
                        className={uploadClass}
                    >
                        {getContent()}
                    </Upload>
                </ImgCrop>
            ) : isNoCrop ? (
                <Upload
                    disabled={disabled}
                    accept={accept}
                    valuePropName={valuePropName}
                    listType="picture-card"
                    style={{ width: '100%' }}
                    showUploadList={false}
                    customRequest={onUploadFile}
                    beforeUpload={beforeUpload}
                    onChange={onChange}
                    className={uploadClass}
                >
                    {getContent()}
                </Upload>
            ) : (
                <ImgCrop aspect={aspect} fillColor="transparent" quality="1">
                    <Upload
                        disabled={disabled}
                        accept={accept}
                        valuePropName={valuePropName}
                        listType="picture-card"
                        style={{ width: '100%' }}
                        showUploadList={false}
                        customRequest={onUploadFile}
                        beforeUpload={beforeUpload}
                        onChange={onChange}
                        className={uploadClass}
                    >
                        {getContent()}
                    </Upload>
                </ImgCrop>
            )}
        </Form.Item>
    );
}

export default CropImageFieldModal;
